import { NICmsContentComponent } from '@icms/core/content';
import { NPageHeader } from '../../../../layout/page/header/page-header.interface';
import { ICmsComponentCwvConfig } from '../../../config/component.config';
import { NAccessRestrictionsModal } from '../../page/access/access-restrictions-modal.interface';

export namespace NCategoryHeader {
    export const ID = 'category-header';

    export interface IData
        extends NICmsContentComponent.IData,
            NPageHeader.IVersionConfig,
            ICmsComponentCwvConfig,
            NAccessRestrictionsModal.IAccessRestrictionsModalData {
        title?: string;
        description?: string;
        image?: string;
        header_type: string;
        display_image: boolean;
        image_ratio: string;
        category_components: NICmsContentComponent.IData[];
    }
}
